import { Button } from '@winnin/winnin_ui.components.button'
import { InputWithLabel } from '@winnin/winnin_ui.components.input-with-label'
import { Modal } from '@winnin/winnin_ui.components.modal'
import { Title } from '@winnin/winnin_ui.components.title'

import { useTranslate } from 'lib/tolgee'
import { MODAL_STYLE } from 'modules/dashboard/common/dashboard.consts'
import { translations as translationsCommon } from 'modules/dashboard/common/dashboard.i18n'
import { TOLGEE_GLOBALS } from 'utils'

import type { TEditDashboardFolderModalViewProps } from './edit-dashboard-folder-modal.types'
import './edit-dashboard-folder-modal.styles.scss'

export const EditDashboardFolderModalView = ({
  folderName,
  handleClose,
  handleEditFolder,
  handleInputChange,
  isOpen,
  isSubmitDisabled,
}: TEditDashboardFolderModalViewProps) => {
  const t = useTranslate()
  return (
    <Modal style={MODAL_STYLE} isOpen={isOpen} onRequestClose={handleClose}>
      <div className="EditDashboardFolderModal">
        <Title tag="h3">{t(translationsCommon.editDashboardFolder)}</Title>
        <InputWithLabel
          label={t(translationsCommon.folderName)}
          placeholder={t(translationsCommon.folderName)}
          onChange={handleInputChange}
          value={folderName}
          name="folderName"
          maxLength={50}
        />
        <div className="buttonsSection">
          <Button appearance="link" onClick={handleClose}>
            {t(TOLGEE_GLOBALS.cancel)}
          </Button>
          <Button onClick={handleEditFolder} disabled={isSubmitDisabled}>
            {t(TOLGEE_GLOBALS.done)}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
